import React from 'react';

const Terms = () => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-black mb-8 font-serif">Terms of Services</h1>
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 mb-6 leading-relaxed">
              Last updated: January 2026
            </p>
            <h2 className="text-2xl font-bold text-black mt-8 mb-4 font-serif">1. Agreement to Terms</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              By accessing and using Worknetix Solutions' services, you agree to be bound by these Terms of Services. If you do not agree to these terms, please do not use our services.
            </p>
            <h2 className="text-2xl font-bold text-black mt-8 mb-4 font-serif">2. Services</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Worknetix Solutions provides comprehensive security and facility management services as described on our website. All services are subject to availability and may be modified or discontinued at any time.
            </p>
            <h2 className="text-2xl font-bold text-black mt-8 mb-4 font-serif">3. Service Agreements</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Specific terms and conditions for each service will be outlined in separate service agreements signed between Worknetix Solutions and the client.
            </p>
            <h2 className="text-2xl font-bold text-black mt-8 mb-4 font-serif">4. Payment Terms</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Payment terms will be specified in individual service agreements. All payments are due as per the agreed schedule.
            </p>
            <h2 className="text-2xl font-bold text-black mt-8 mb-4 font-serif">5. Limitation of Liability</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Worknetix Solutions shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services.
            </p>
            <h2 className="text-2xl font-bold text-black mt-8 mb-4 font-serif">6. Contact Information</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              For questions about these Terms of Services, please contact us through our contact page.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Terms;
